var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.98 35.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#485aa5;}.cls-1{stroke:#485aa5;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.92,25.37a3.65,3.65,0,0,1-.41-1.73V18.28a5.39,5.39,0,0,0-5.36-5.36,5.1,5.1,0,0,0-3.79,1.58,5.15,5.15,0,0,0-1.56,3.78,5.27,5.27,0,0,0,1.56,3.8,5.19,5.19,0,0,0,3.79,1.56h1.56a3.69,3.69,0,0,1,3.48,2.27,3.78,3.78,0,0,1,.32,1.51H26.15a8.87,8.87,0,0,1-7.42-3.78A9,9,0,0,1,17,18.28a9.13,9.13,0,0,1,9.15-9.15h.47a8,8,0,0,1,1,.12,5.41,5.41,0,0,1,1.06.22,8,8,0,0,1,1,.34,9.79,9.79,0,0,1,1.82,1l.06,0a10.83,10.83,0,0,1,1.11.94,8.8,8.8,0,0,1,2.67,6.47v9.14A3.67,3.67,0,0,1,31.92,25.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.11,18.28a9.13,9.13,0,0,1,9.14-9.15,8.77,8.77,0,0,1,6.47,2.68,8.76,8.76,0,0,1,2.67,6.47,8.81,8.81,0,0,1-2.67,6.47,9,9,0,0,1-6.47,2.67H43a3.77,3.77,0,0,1,1.11-2.69,3.71,3.71,0,0,1,2.69-1.11h.49a5.33,5.33,0,0,0,5.34-5.34A5.12,5.12,0,0,0,51,14.5a5.31,5.31,0,0,0-7.56,0,5.15,5.15,0,0,0-1.56,3.78V31.52a3.79,3.79,0,0,1-3.8,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.71,27.42a3.79,3.79,0,0,1,3.78-3.78h1.73a1.73,1.73,0,1,0,0-3.46,5.28,5.28,0,0,1-1.73-.29,5.42,5.42,0,0,1-2.42-1.61,5.32,5.32,0,0,1-1.36-3.63,5.3,5.3,0,0,1,1.6-3.9,5.36,5.36,0,0,1,3.91-1.62h5.53a3.59,3.59,0,0,1-.92,2.47A3.68,3.68,0,0,1,65,12.93H63.22a1.73,1.73,0,1,0,0,3.45,5.22,5.22,0,0,1,4.16,1.9,5.5,5.5,0,0,1-.24,7.52,5.38,5.38,0,0,1-3.92,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.49,25.37a3.79,3.79,0,0,1-.41-1.75c0-3.69,0-5.59,0-5.72a5.37,5.37,0,0,0-1.56-3.4,5.34,5.34,0,0,0-9.12,3.78v5.34a3.81,3.81,0,0,1-.44,1.75,3.66,3.66,0,0,1-3.36,2.05V.5a3.79,3.79,0,0,1,3.8,3.78v6.59a7.75,7.75,0,0,1,1.22-.76,9,9,0,0,1,4.12-1A9.18,9.18,0,0,1,86,10.81a7.54,7.54,0,0,1,1.17,1,8.76,8.76,0,0,1,2.67,6.47v9.14A3.67,3.67,0,0,1,86.49,25.37ZM82.6,7.67c.13.17.26.35.38.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.68,5.75a3.66,3.66,0,0,1,1.11-2.67A3.72,3.72,0,0,1,96.48,2V3.25a3.66,3.66,0,0,1-1.11,2.67A3.68,3.68,0,0,1,92.68,7Zm0,7.17a3.7,3.7,0,0,1,1.11-2.68,3.76,3.76,0,0,1,2.69-1.11V23.62a3.79,3.79,0,0,1-3.8,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.94,16.15h0L9.21,16l1-1.24A23.28,23.28,0,0,0,7.32,9.37,57.23,57.23,0,0,0,2.07,4.73h0L1,6,0,.31H0L5.89.44,4.83,1.67A17,17,0,0,0,7.62,7.21a49.5,49.5,0,0,0,5.2,4.37h0l1.05-1.23,1,5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.52,14.57v13H4.39a3.9,3.9,0,0,1-3.9-3.9V8.7L2,7.19,4.9,9.72C6.31,10.94,5.52,12.71,5.52,14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.62,5.49V7.32H12.41c-1.86,0-3.53.24-4.23-1.85l-1-2.59H17.47A2.41,2.41,0,0,1,19.62,5.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7868f5910a4085e09b3f91e67d5a1cd5.svg";
export { ForwardRef as ReactComponent };